import Vue from 'vue';
import store from '../store';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Trainings from '../views/Trainings.vue';
import Settings from '../views/Settings.vue';
import Records from '../views/Records.vue';
import Expected from '../views/Expected.vue';
import Dashboard from '../views/Dashboard.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {
    path: '/trainings',
    name: 'Trainings',
    component: Trainings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/records',
    name: 'Records',
    component: Records,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/expected',
    name: 'Expected',
    component: Expected,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    store
      .dispatch('checkLogin')
      .then(() => {
        // console.log('router_login_OK:');
        next();
        return;
      })
      .catch((err) => {
        if (err === 'noSession') {
          store.commit('globalMessage', 'Vypršela platnost přihlášení');
          router.push('/');
        }
      });
  } else {
    next();
  }
});

export default router;
